<template>
  <div
    class="max-w-2xl mx-auto"
    :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
  >
    <div
      class="text-xl font-bold text-center pb-44"
      v-if="isSuccess"
      v-html="success"
    ></div>
    <form @submit.prevent="onSubmit" v-else>
      <p class="text-xl font-bold text-center mb-10" :style="$themeStyle">
        {{ title }}
      </p>

      <InputText
        :hint="getHint(email, isEmailValid, 'email').text"
        :hint-state="getHint(email, isEmailValid, 'email').state"
        :placeholder="$t('newsletterPlaceholderEmail')"
        type="email"
        v-model="email"
      />
      <InputText
        :hint="getHint(name, isNameValid, 'name').text"
        :hint-state="getHint(name, isNameValid, 'name').state"
        :placeholder="$t('newsletterPlaceholderName')"
        type="text"
        v-model="name"
      />
      <InputSelect
        class="mb-8"
        :hint="getHint(country, isCountryValid, 'country').text"
        :hint-state="getHint(country, isCountryValid, 'country').state"
        :options="$tParticipatingCountriesItems"
        :placeholder="$t('newsletterPlaceholderCountry')"
        v-model="country"
      />
      <div class="w-full md:w-134 md:mx-auto input mb-8">
        <div v-html="terms"></div>
      </div>
      <Button
        type="submit"
        :title="button"
        :isFullWidth="false"
        :isDisabled="!isFormValid"
      />
    </form>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import cms from '../../cms'
import { ThemeHandler } from '../../mixins/theme-handler'
import { TranslationHandler } from '../../mixins/translation-handler'
import { PageModule, PageModuleDataNewsletter } from '../../types'

@Component({
})
export default class ModuleNewsletter extends Mixins(TranslationHandler, ThemeHandler) {
  @Prop() pageModule!: PageModule<PageModuleDataNewsletter>

  @Getter themePrimaryColor!: string
  @Getter themeIsDark!: boolean

  get title () {
    return this.pageModule.data[this.$tLocaleCurrent].title
  }

  get terms () {
    return this.pageModule.data[this.$tLocaleCurrent].terms
  }

  get button () {
    return this.pageModule.data[this.$tLocaleCurrent].button
  }

  get success () {
    return this.pageModule.data[this.$tLocaleCurrent].success
  }

  name = ''
  email = ''
  country = ''
  isTermsChecked = false

  isSuccess = false

  hints: { [k: string]: { valid: string, invalid: string } } = {
    email: {
      valid: this.$t('newsletterHintEmailValid'),
      invalid: this.$t('newsletterHintEmailInvalid'),
    },
    country: {
      valid: this.$t('newsletterHintCountryValid'),
      invalid: this.$t('newsletterHintCountryInvalid'),
    },
    name: {
      valid: this.$t('newsletterHintNameValid'),
      invalid: this.$t('newsletterHintNameInvalid'),
    }
  }

  getHint (val: string, isValid: boolean, type: string): { text: string, state: 'error' | 'default' | 'success' } {
    if (val.length === 0) {
      return { text: '', state: 'default' }
    }

    return isValid
      ? {
        text: this.hints[type].valid,
        state: 'success'
      }
      : {
        text: this.hints[type].invalid,
        state: 'error'
      }
  }

  get isNameValid (): boolean {
    return this.name.length > 0
  }

  get isEmailValid (): boolean {
    return this.email.length > 0 && (/\S+@\S+\.\S+/).test(this.email)
  }

  get isCountryValid (): boolean {
    return this.country.length > 0
  }

  get isFormValid (): boolean {
    return [
      this.isNameValid,
      this.isEmailValid,
      this.isCountryValid
    ].every(v => !!v)
  }

  async onSubmit () {
    if (this.isFormValid === false) { return }

    try {
      await cms.newsletter.signup({
        email: this.email,
        name: this.name,
        country: this.country,
      })
      this.isSuccess = true
    } catch (e) {
      console.error(e)
      alert(e)
    }
  }
}
</script>
